<template>
    <form id="form-consulta needs-validation" novalidate @submit.prevent="submitForm" @reset="onReset" method="post" role="form" class="php-email-form">
		<div class="row">
			<div class="col-md-6 form-group">
				<select :class="formData.errores && formData.errores.area ? 'is-invalid' : ''" v-model="formData.values.area" name="area" class="form-select" id="area" placeholder="Area" required>
					<option value="" disabled selected>Selecione una área de contacto...</option>
					<option v-if="datos_site.site_areas" 
					        v-for="area_item of datos_site.site_areas" 
							:key="area_item.id_area"
							:value="area_item.id_area">
						{{ area_item.area }}
					</option>
				</select>
				<div class="invalid-feedback">Por favor ingrese el area al que va dirigido.</div>
			</div>
			<div class="col-md-6 form-group mt-3 mt-md-0">
				<select :class="formData.errores && formData.errores.tema ? 'is-invalid' : ''" v-model="formData.values.tema" name="tema" class="form-select" id="tema" placeholder="Tema" >
					<option value="" disabled selected>Selecione un tema de contacto...</option>
					<option v-if="datos_site.contacto_temas" 
					        v-for="temas_item of datos_site.contacto_temas.filter(c => c.id_area == formData.values.area)" 
							:key="temas_item.id_tema"
							:value="temas_item.id_tema">
						{{ temas_item.tema }}
					</option>
				</select>
				<div class="invalid-feedback">No ha ingresado un tema válido.</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 form-group">
				<input :class="formData.errores && formData.errores.name ? 'is-invalid' : ''" type="text" v-model="formData.values.name" name="name" class="form-control" id="name" placeholder="Tu Nombre" required>
				<div class="invalid-feedback">Por favor ingrese su nombre.</div>
			</div>
			<div class="col-md-6 form-group mt-3 mt-md-0">
				<input :class="formData.errores && formData.errores.email ? 'is-invalid' : ''" type="email" v-model="formData.values.email"  class="form-control" name="email" id="email" placeholder="Tu Correo Electrónico" required>
				<div class="invalid-feedback">No ha ingresado un email válido.</div>
			</div>
		</div>
		<div class="form-group mt-3">
			<textarea :class="formData.errores && formData.errores.message ? 'is-invalid' : ''" class="form-control" v-model="formData.values.message" name="message" rows="5" placeholder="Tu Consulta" required></textarea>
			<div class="invalid-feedback">Debe escribir el motivo de su contacto.</div>
		</div>
		<div class="my-3">
			<div :class="formData.loading ? 'd-block' : ''" class="loading">Loading</div>
			<div :class="formData.success ? 'd-block' : ''" class="sent-message">Su mensaje ha sido enviado. ¡Muchas Gracias!</div>
			<div :class="formData.error ? 'd-block' : ''" class="error-message">Ocurrió un error por favor intente nuevamente más tarde</div>
		</div>
		<div class="text-end pe-3">
			<button id="btn-consulta" type="submit" class="btn btn-primary">
			<span v-if="!formData.loading" class="txt">Enviar Consulta</span>
			<span v-if="formData.loading" class="action"><i class="bx bx-loader bx-spin"></i> Enviando consulta </span>
			</button>
		</div>
	</form>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
export default{
    name: 'FormConsultaComponent',
  	props: {
        'src':{
            type: String
        },
        'height':{
            type: Number,
            default: 350
        }
    },
	computed: {
		
	},
	setup(){
		const store = useStore()
        const datos_site = computed(() => store.state.datos)
       

		const formValid =() =>{
			let error = false
			formData.value.errores.name = false
			formData.value.errores.email = false
			formData.value.errores.message = false
			formData.value.errores.area = false
			formData.value.errores.tema = false
			
			if(!(formData.value.values.area > 0)){
				formData.value.errores.area = true
				error = true
			}

			if(!(formData.value.values.name.length > 0)){
				formData.value.errores.name = true
				error = true
			}
			if(!(/(.+)@(.+){2,}.(.+){2,}/.test(formData.value.values.email))){
				formData.value.errores.email = true
				error = true
			}
			if(!(formData.value.values.message.length > 0)){
				formData.value.errores.message = true
				error = true
			}
			return !( error )
		}

		const formData = ref({
			values: {
				name: '',
				email: '',
				message: '',
				area: '',
				tema: ''
			},
			error: false,
			errores: { name: false, email: false, message: false, area: false, tema: false },
			success: false,
			loading: false
		})

		// Watch para observar cambios en el área
		watch(() => formData.value.values.area, (newArea, oldArea) => {
		if (newArea !== oldArea) {
			// Resetear el tema cuando cambia el área
			formData.value.values.tema = '';
			
			// También resetear el error del tema si existe
			if (formData.value.errores.tema) {
			formData.value.errores.tema = false;
			}
		}
		});

		const onReset = () => {
			formData.value.values = {
				...formData.value.values,
				name: '',
				email: '',
				message: '',
				area: '',
				tema: ''
			}
		}

		const submitForm = async () => {
			formData.value.error = false
			formData.value.success = false
			formData.value.loading = true

			if(!formValid()){
				formData.value.loading = false
				return false
			}

			await fetch('contact/create', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData.value.values)
			})
			.then(async response => {
				formData.value.loading = false
				if(response.ok) {
					formData.value.success = true
					onReset()
				} else {
					const responseData = await response.json();
					if (responseData?.errors && Object.keys(responseData.errors).length > 0) {
						formData.value.errores = responseData.errors
					}
					throw new Error("Not 2xx response", {cause: response})
				}
			})
			.catch(async (error) => {
				// Si el error viene con una respuesta que contiene JSON
				// Usar los datos del error que ya parseamos
				if (error.cause?.errors && Object.keys(error.cause.errors).length > 0) {
					formData.value.errores = error.cause.errors;
				}
				formData.value.error = true;
			})
		}

		return {
			formData,
			submitForm,
			onReset,
			datos_site
		}
	}
}
</script>